<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok"  :loading="loading" :width="900"
           :ok-text="'确定'">
        <h3 slot="header" class="modal-header">退款渠道明细</h3>
        <Table :columns="columnCase1" :data="infoData" class="mb8"></Table>
    </Modal>
  </div>
</template>

<script>
  import {getRefunDetailsByBusid} from "api/contractList";

  export default {
    name: "RefundDetail",
    props: {
      n: {
        type: Number,
        default: 0
      },
      busId: {
        type: String,
        default: ''
      }
    },
    watch: {
      n() {
        this.isShow = true;
        this.getRefundDetailByBusId();
      },
    },
    data() {
      return {
        isShow: false,
        loading: true,
        infoData: [{"paymentCanalName":"1111"}],
        columnCase1: [
          {
            title: "渠道",
            key: "paymentCanalName",
            align: "center"
          },
          {
            title: "退款金额",
            key: "payAmountY",
            align: "center"
          },
          {
            title: "收款单号",
            key: "receiptNum",
            align: "center"
          },
          {
            title: "退款状态",
            key: "payStatusStr",
            align: "center",
//            render:(h,params)=>{
//              return h('span',{
//                style:{
//                  color:'red'
//                }
//              },params.row['paymentStatusName'])
//            }
          },
          {
            title: "备注",
            key: "mark",
            align: "center",
          }


        ],
      }
    },
    methods: {
      ok() {
        this.isShow=false
        this.loading = false;
        return;
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      getRefundDetailByBusId() {
        const params = {
          busid: this.busId
        }
        getRefunDetailsByBusid(params).then(res => {
          if(!res.data){
            return
          }
          this.infoData=res.data
        }).catch(error => {

        })

      },
    },

  }
</script>

<style scoped>
  .upload {
    display: inline-block;
    width: 60px;
    height: 60px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 80px;
  }

  .fileItem {
    margin-right: 20px;
  }

  .content-right {
    /*border: 1px solid black;*/
    overflow: hidden;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;

  }

  .file-img {
    width: 150px;
    height: 85px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }

  .input-width {
    width: 150px;
    margin-bottom: 10px;
  }


</style>
